import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Landing from "./components/Landing";
import Privacy from "./components/Privacy";
import Consent from "./components/Consent";
import Login from "./components/Login";
import Register from "./components/Register";
import Campaigns from "./components/Campaigns";
import LeadSources from "./components/LeadSources";
import ErrorPage from "./components/ErrorPage";
import Leads from "./components/Leads";
import Users from "./components/Users";
import Campaign from "./components/Campaign";
import LeadSource from "./components/LeadSource";
import Lead from "./components/Lead";
import User from "./components/User";
import EditUser from "./components/EditUser";
import CampaignsAdmin from "./components/CampaignsAdmin";

const router = createBrowserRouter([
    { path: "/", element: <Landing />, errorElement: <ErrorPage /> },
    { path: "/privacy", element: <Privacy />, errorElement: <ErrorPage /> },
    { path: "/consent", element: <Consent />, errorElement: <ErrorPage /> },
    { path: "/login", element: <Login />, errorElement: <ErrorPage /> },
    { path: "/register", element: <Register />, errorElement: <ErrorPage /> },
    {
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            { path: "/campaigns", element: <Campaigns /> },
            { path: "/campaigns-admin", element: <CampaignsAdmin /> },
            { path: "/campaigns/:id", element: <Campaign /> },
            { path: "/sources", element: <LeadSources /> },
            { path: "/sources/:id", element: <LeadSource /> },
            { path: "/leads", element: <Leads /> },
            { path: "/leads/:id", element: <Lead /> },
            { path: "/users", element: <Users /> },
            { path: "/users/:id", element: <User /> },
            { path: "/users/:id/edit", element: <EditUser /> },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
